import { useMemo } from 'react';
import { TaskFilters } from 'react-scale/components/ExpertManagement/ExpertManagementPage/BulkAudit/useChatBulkAuditFilterComponents';

export const useChatBulkAuditFiltering = (projectTasks: any[], bodyFilters: TaskFilters) => {
  const filteredTasks = useMemo(
    () =>
      projectTasks.filter(
        task =>
          (bodyFilters.reviewLevels === undefined ||
            bodyFilters.reviewLevels.includes(task.attemptedAtReviewLevel)) &&
          (bodyFilters.hasBeenAudited === undefined ||
            !!task.attemptAudit === bodyFilters.hasBeenAudited),
      ),
    [projectTasks, bodyFilters.reviewLevels, bodyFilters.hasBeenAudited],
  );

  return {
    filteredTasks,
  };
};
